import { isIElasticErrorResponse, isIElasticSearchItemsResponse, } from "./esUtils";
const zeroItems = () => {
    return {
        itemsTotal: 0,
        items: [],
    };
};
const getNormalizedItems = (elasticSrc) => {
    if (!elasticSrc) {
        return zeroItems();
    }
    if (isIElasticErrorResponse(elasticSrc)) {
        console.warn("⚠️ getNormalizedItems", { elasticSrc });
        return zeroItems();
    }
    if (isIElasticSearchItemsResponse(elasticSrc)) {
        const res = elasticSrc.hits.hits.map((o) => ({
            id: o._id,
            data: o._source,
            sort: o.sort,
        }));
        return { itemsTotal: elasticSrc.hits.total.value, items: res };
    }
    return zeroItems();
};
export default getNormalizedItems;
